import { render, staticRenderFns } from "./VueCropper.vue?vue&type=template&id=50c8ecba&scoped=true"
import script from "./VueCropper.vue?vue&type=script&lang=js"
export * from "./VueCropper.vue?vue&type=script&lang=js"
import style1 from "./VueCropper.vue?vue&type=style&index=1&id=50c8ecba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c8ecba",
  null
  
)

export default component.exports